import styled from 'styled-components'

import { deviceMax } from '../../../theme/breakpoints'
import pxToRem from '../../../utils/pxToRem'

import Carousel from '../../Carousel/Carousel'
import CarrouselSlide from '../CarrouselSlide/CarrouselSlide'

export const StyledCarrouselPopin = styled.div`
  z-index: 99;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.opacity.black70};
`

export const StyledContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${pxToRem(20)};
  padding: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
  width: 100%;
  max-width: ${pxToRem(800)};
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.mobileL} {
    width: 90%;
  }
`

export const StyledCloseBtn = styled.div`
  top: ${pxToRem(16)};
  right: ${pxToRem(16)};
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: pointer;
`

export const StyledLargeCarousel = styled(Carousel)`
  display: flex;
  flex-direction: column-reverse;
  gap: ${pxToRem(20)};
  width: 100%;
  max-width: initial;
  margin: initial;
  padding: initial;

  div {
    margin: initial;
  }

  .slick-list {
    border-radius: ${pxToRem(4)} ${pxToRem(4)} ${pxToRem(40)} ${pxToRem(4)};
  }
`

export const StyledCarrouselSlide = styled(CarrouselSlide)`
  width: 100%;
  height: ${pxToRem(480)};
  max-height: ${pxToRem(480)};

  @media ${deviceMax.mobileL} {
    height: ${pxToRem(200)};
  }
`
